'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { MD5 } from 'crypto-js';
import useGlobalState from '@hooks/useGlobalState';

function HomeScriptTags() {
  const { assistData } = useGlobalState();
  const [sid, setSid] = useState<string>('');

  // useEffect(() => {
  //   const getSid = async () => {
  //     const tempSid = (await getWckDisplaySID()) as string;
  //     console.log('tempSid', tempSid);
  //     setSid(tempSid);
  //   };
  //   getSid();
  // }, []);

  return (
    <>
      {/* <!--마케팅로그:메인:CRITEO//--> */}
      <Script
        type="text/javascript"
        strategy="lazyOnload"
        src="https://static.wconcept.co.kr/p/js/criteo-new.js"
      />
      <Script
        id="criteo"
        strategy="lazyOnload"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
          window.criteo_q = window.criteo_q || [];
          
          window.criteo_q.push(
            { event: 'setAccount', account: 5705 },
            {
              event: 'setHashedEmail',
              email: '${
                assistData.user.userId
                  ? MD5(assistData.user.userId).toString()
                  : ''
              }',
            },
            { event: 'setSiteType', type: 'm' },
            { event: 'viewHome' },
          );
        `,
        }}
      />
      {/* <!--//마케팅로그:메인:CRITEO--> */}

      {/* 마케팅로그:Footer:구글 GDN */}
      {/* //  GDN DDN 스크립트 부분 */}
      {/* <Script
        id="gdnDdnScript"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
          var google_tag_params = {
            // TODO
            ecomm_prodid: "${sid}",        //제품 고유 번호 세팅 ex) 300301675, 여러 상품이 등록되어 있는 페이지라면 모든 번호가 보일 수 있도록 세팅
            ecomm_pagetype: "home"                          //유저가 머물고 있는 페이지 정보
          };
        `,
        }}
      /> */}
      <Script
        id="gdnScript"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
          var google_conversion_id = 1011283155;
          var google_conversion_label = "6GuqCPXQgQcQ0-mb4gM";
          var google_custom_params = window.google_tag_params;
          var google_remarketing_only = true;
        `,
        }}
      />
      <Script
        strategy="lazyOnload"
        type="text/javascript"
        src="https://www.googleadservices.com/pagead/conversion.js"
      />
      <noscript>
        <div style={{ display: 'inline' }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            height="1"
            width="1"
            style={{ borderStyle: 'none' }}
            alt=""
            src="https://googleads.g.doubleclick.net/pagead/viewthroughconversion/1011283155/?value=1.00&currency_code=KRW&label=6GuqCPXQgQcQ0-mb4gM&guid=ON&script=0"
          />
        </div>
      </noscript>
    </>
  );
}

export default HomeScriptTags;
